import DateField from 'components/StraightThroughHouseholdComp/CustomInputs/DateField/DateField';
import NameField from 'components/StraightThroughHouseholdComp/CustomInputs/NameField/NameField';
import { RadioButtonField } from 'components/StraightThroughHouseholdComp/CustomInputs/RadioButtonField/RadioButtonField';
import SelectDropdown from 'components/StraightThroughHouseholdComp/CustomInputs/SelectDropdown/SelectDropdown';
import dlStatus from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/DLStatus';
import editHhmOptions from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/EditHhmOptions';
import states from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/States';
import TextField from 'components/StraightThroughHouseholdComp/CustomInputs/TextField/TextField';
import { useDriverHHM } from 'components/StraightThroughHouseholdComp/HouseholdContext/DriverHHMContext';
import HelpfulDocumentsNJ from 'components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsNJ/HelpfulDocumentsNJ';
import HelpfulDocumentsPA from 'components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsPA/HelpfulDocumentsPA';
import { useState } from 'react';

const UpdateHhmForm = ({ context, changeClass }) => {
    const driverContext = useDriverHHM();
    const { driverHHM, driverHHMCallback } = driverContext;
    const blIsMichigan = context?.userData?.state === 'Michigan';
    const blIsNewJersey = context?.userData?.state === 'New Jersey';
    const [requestedEffDate, setRequestedEffDate] = useState();
    
    return (
        <>
            <h5 className='text-primary text-center fw-bold my-3'>UPDATE HOUSEHOLD MEMBER</h5>
            <div style={{margin:"0px 0.5rem", padding: "0px 0.75rem"}}>
            <NameField
                name={`${driverHHM?.userInfo.firstName} ${driverHHM.userInfo.lastName}`}
                dob={`${driverHHM?.userInfo.dobMonth}/${driverHHM?.userInfo.dobDay}/${driverHHM?.userInfo.dobYear}`}
            />

            {/* Edit Type */}
            <SelectDropdown
                label={"What would you like to edit about this household member?*"}
                name={"editType"}
                value={driverHHM?.editType}
                dropdown={editHhmOptions(driverContext?.calculateAge())}
                setCallback={driverHHMCallback}
            />

            {context?.addressChangeClass?.requestType !== "Address Change" && driverHHM?.editType && 
            <DateField
                label="Requested Effective Date*"
                dateSubmit={driverHHM?.requestedEffDate?driverHHM?.requestedEffDate:requestedEffDate}
                setDateSubmit={setRequestedEffDate}
                storeValue={driverHHMCallback}
                nameValue="requestedEffDate"
                infoKey="requestedEffDate"
                // noMinMax={true}
            />
            }

            {
                driverHHM?.editType === 'Add as driver on policy.' &&
                <>
                    {/* Current License Status */}
                    <SelectDropdown
                        label={"What is the current status of this driver's license?*"}
                        name={"licenseStatus"}
                        infoKey='driverInfo'
                        value={driverHHM?.driverInfo?.licenseStatus}
                        dropdown={dlStatus(context?.userData?.state)}
                        setCallback={driverHHMCallback}
                    />

                    {
                        driverHHM?.driverInfo?.licenseStatus &&
                        driverHHM?.driverInfo?.licenseStatus !== 'Select from the following...' &&
                        <>
                            {/* Age Licensed */}
                            <TextField
                                label={"Age Licensed*"}
                                name={"licenseAge"}
                                infoKey='driverInfo'
                                value={driverHHM?.driverInfo?.licenseAge}
                                setCallback={driverHHMCallback}
                            />

                            {/* License State */}
                            <SelectDropdown
                                label={blIsNewJersey ? "In what state is this driver licensed?*" : "License State*"}
                                name={"licenseState"}
                                infoKey='driverInfo'
                                value={driverHHM?.driverInfo?.licenseState || context?.userData?.state}
                                dropdown={states}
                                setCallback={driverHHMCallback}
                            />

                            {/* License Number */}
                            <TextField
                                label={"License Number*"}
                                name={"licenseNumber"}
                                infoKey='driverInfo'
                                value={driverHHM?.driverInfo?.licenseNumber}
                                setCallback={driverHHMCallback}
                            />
                        </>
                    }

                    {/* Occupation */}
                    <TextField
                        label={"What is this person's occupation?*"}
                        infoKey='userInfo'
                        name={"occupation"}
                        value={driverHHM?.userInfo?.occupation}
                        setCallback={driverHHMCallback}
                    />

                    <hr />
                    {
                        blIsMichigan &&
                        <>
                            {/* Convicted */}
                            <RadioButtonField
                                question={`Has this person been convicted in the past 5 years of fraud or intent to defraud involving an insurance claim or an application for insurance; 
                                    Or has this person successfully been denied in the past 5 years, payment of a claim over $1,000.00 under an auto insurance policy, if there was evidence 
                                    or fraud or the intent to defraud involving an insurance claim or application?*`}
                                uw={true}
                                name={"convicted"}
                                infoKey='violationInfo'
                                value={driverHHM?.violationInfo?.convicted || ""}
                                setCallback={driverHHMCallback}
                            />
                        </>
                    }
                    {
                        !blIsMichigan && <>
                            {/* Mental/Physical Impairments */}
                            <RadioButtonField
                                question={"Does this driver have any mental or physical impairments, other than those listed above, that would impair their ability to operate a motor vehicle safely (Not including prescription eyeglasses or contact lenses)?*"}
                                uw={true}
                                name={'physicalImpairments'}
                                infoKey='disabilityInfo'
                                value={driverHHM?.disabilityInfo?.physicalImpairments || ""}
                                setCallback={driverHHMCallback}
                            />

                            {/* Licensed under different name */}
                            <RadioButtonField
                                question={"Has this driver been licensed under a different name within the past 36 months?*"}
                                uw={true}
                                name={'diffNameLicensed'}
                                infoKey='driverInfo'
                                value={driverHHM?.driverInfo?.diffNameLicensed ? driverHHM?.driverInfo?.diffNameLicensed : ""}
                                setCallback={driverHHMCallback}
                            />

                            {/* Licensed under different state/country */}
                            <RadioButtonField
                                question={"Has this driver been licensed in another state or country within the past 36 months?*"}
                                uw={true}
                                name={'diffStateLicensed'}
                                infoKey='driverInfo'
                                value={driverHHM?.driverInfo?.diffStateLicensed ? driverHHM?.driverInfo?.diffStateLicensed : ""}
                                setCallback={driverHHMCallback}
                            />

                            {/* Moving violations */}
                            <RadioButtonField
                                question={"Has this driver received any Moving Violations and/or been in any Accidents or Claims in the last 36 months, regardless of fault?*"}
                                uw={true}
                                name={'movingViolations'}
                                infoKey='violationInfo'
                                value={driverHHM?.violationInfo?.movingViolations ? driverHHM?.violationInfo?.movingViolations : ""}
                                setCallback={driverHHMCallback}
                            />

                            {/* Suspended */}
                            <RadioButtonField
                                question={"Has this driver’s license been suspended or in a suspended status in the last 36 months?*"}
                                uw={true}
                                name={'driverSuspended'}
                                infoKey='violationInfo'
                                value={driverHHM?.violationInfo?.driverSuspended ? driverHHM?.violationInfo?.driverSuspended : ""}
                                setCallback={driverHHMCallback}
                            />

                            {/* Enrolled in college/university */}
                            <RadioButtonField
                                question={'Is this driver enrolled in a college or university?*'}
                                infoKey='schoolInfo'
                                name={'enrolledInCollege'}
                                uw={true}
                                value={driverHHM?.schoolInfo?.enrolledInCollege || ''}
                                setCallback={driverHHMCallback}
                            />

                            {blIsNewJersey &&
                                <>
                                    <RadioButtonField
                                        question={"Does this applicant have custody of a minor?*"}
                                        uw={true}
                                        name={'minorCustody'}
                                        infoKey='userInfo'
                                        value={driverHHM?.userInfo?.minorCustody ? driverHHM?.userInfo?.minorCustody : ""}
                                        setCallback={driverHHMCallback}
                                    />
                                </>
                            }

                        </>
                    }
                    {/* Military */}
                    <RadioButtonField
                        question={"Is the driver a member of any branch of military?*"}
                        uw={true}
                        name={"militaryMember"}
                        infoKey='userInfo'
                        value={driverHHM?.userInfo?.militaryMember || ""}
                        setCallback={driverHHMCallback}
                    />

                    {/* Disorders */}
                    <RadioButtonField
                        question={"Does the driver have a disorder or condition that may impair their ability to safely operate a motor vehicle, including but not limited to Narcolepsy, Syncope, Blindness, or Seizures?*"}
                        uw={true}
                        name={"disorders"}
                        infoKey='disabilityInfo'
                        value={driverHHM?.disabilityInfo?.disorders ? driverHHM?.disabilityInfo?.disorders : ""}
                        setCallback={driverHHMCallback}
                    />
                    {
                        blIsMichigan &&
                        <div style={{ marginRight: '12px' }}>
                            <p className='text-primary fw-bold field'>
                                Has the driver been convicted of, or has been subject to an order of disposition of the family division of circuit court for a violation
                                of any of the following, within the last 3 years:
                            </p>

                            <div className='ms-3'>
                                {/* Moving violation resulting in death/serious impairment */}
                                <RadioButtonField
                                    question={
                                        'a. Moving violation causing death or serious impairment of body function; or any other Michigan law for which a violation constitutes a felony resulting from the operation of a motor vehicle.*'
                                    }
                                    uw={true}
                                    name={'seriousMovingViolations'}
                                    infoKey='violationInfo'
                                    value={driverHHM?.violationInfo?.seriousMovingViolations ? driverHHM?.violationInfo?.seriousMovingViolations : ""}
                                    setCallback={driverHHMCallback}
                                />

                                {/* Under influence */}
                                <RadioButtonField
                                    question={'b. Operation of motor vehicle while under influence.*'}
                                    uw={true}
                                    name={'underInfluence'}
                                    infoKey='violationInfo'
                                    value={driverHHM?.violationInfo?.underInfluence || ""}
                                    setCallback={driverHHMCallback}
                                />

                                {/* Failure to stop resulting in serious impairment */}
                                <RadioButtonField
                                    question={'c. Failure to stop when involved in an accident that results in serious impairment of a body function or death.*'}
                                    uw={true}
                                    name={'impairment'}
                                    infoKey='violationInfo'
                                    value={driverHHM?.violationInfo?.impairment || ""}
                                    setCallback={driverHHMCallback}
                                />

                                {/* Failure to stop resulting in injury */}
                                <RadioButtonField
                                    question={'d. Failure to stop when involved in an accident that results in injury to any individual.*'}
                                    uw={true}
                                    name={'ftsInjury'}
                                    infoKey='violationInfo'
                                    value={driverHHM?.violationInfo?.ftsInjury ? driverHHM?.violationInfo?.ftsInjury : ""}
                                    setCallback={driverHHMCallback}
                                />

                                {/* Failure to stop resulting in vehicle damage */}
                                <RadioButtonField
                                    question={
                                        'e. Failure to stop when involved in an accident that results in damage to a vehicle operated by or attended by any individual.*'
                                    }
                                    uw={true}
                                    name={'vehicleDamage'}
                                    infoKey='violationInfo'
                                    value={driverHHM?.violationInfo?.vehicleDamage ? driverHHM?.violationInfo?.vehicleDamage : ""}
                                    setCallback={driverHHMCallback}
                                />

                                {/* Failure to provide required info */}
                                <RadioButtonField
                                    question={'f. Failure to provide required information or to provide reasonable assistance to an injured individual.*'}
                                    uw={true}
                                    name={'provideInfoFailure'}
                                    infoKey='violationInfo'
                                    value={driverHHM?.violationInfo?.provideInfoFailure ? driverHHM?.violationInfo?.provideInfoFailure : ""}
                                    setCallback={driverHHMCallback}
                                />

                                {/* Reckless driving */}
                                <RadioButtonField
                                    question={'g. Reckless Driving, or a similar violation under the laws of any other state or municipality in or outside of Michigan.*'}
                                    uw={true}
                                    name={'recklessDriving'}
                                    infoKey='violationInfo'
                                    value={driverHHM?.violationInfo?.recklessDriving ? driverHHM?.violationInfo?.recklessDriving : ""}
                                    setCallback={driverHHMCallback}
                                />
                            </div>
                            <hr />
                            {/* Moving violations */}
                            <RadioButtonField
                                question={'Has driver received any moving violations, or accidents and/or Claims, regardless of fault, in the last 36 months?*'}
                                uw={true}
                                name={'movingViolations'}
                                infoKey='violationInfo'
                                value={driverHHM?.violationInfo?.movingViolations ? driverHHM?.violationInfo?.movingViolations : ""}
                                setCallback={driverHHMCallback}
                            />
                        </div>
                    }
                </>
            }

            {/* New Jersey/Pennsylvania */}
            {!blIsMichigan && (
                <>
                    <hr />
                    {/* Helpful Documents (New Jersey & Pennsylvania Only) */}
                    {blIsNewJersey ? (
                        <div className='text-center'>
                            <HelpfulDocumentsNJ policyType={context?.userData?.policyType} />
                        </div>
                    ) : (
                        <>
                            <HelpfulDocumentsPA center='center' />
                        </>
                    )}
                </>
            )}
            </div>
        </>
    )
}

export default UpdateHhmForm